module.exports = __webpack_public_path__ + "static/media/brandStandout.1bfadf5c.png";